<template>
    <q-dialog v-model="showModal" persistent ref="dialog">
        <q-card style="max-width: 600px;" class="full-width">
            <q-card-section>
                <div class="text-h6 row items-center">
                    <q-icon name="mdi-timelapse" size="sm" class="q-mr-xs" /><span class="gt-xs">Subscription&nbsp;</span> Reinstatement
                    <q-space />
                    <q-btn icon="mdi-close" flat round dense v-close-popup @click="complete" />
                </div>
            </q-card-section>

            <q-card-section class="q-py-none">
                <q-list bordered separator class="q-mb-md">

                    <q-item v-for="item in items" :key="item.id">
                        <q-item-section v-html="item.lapsedSubscriptionReinstatmentDescription" class="text-caption">
                        </q-item-section>
                    </q-item>
                </q-list>
            </q-card-section>

            <q-card-section class="q-pt-none">

                <div class="row q-col-gutter-sm">
                    <div class="col-xs-12 col-sm-auto">
                        <q-btn label="Continue to Cart" color="primary" v-close-popup @click="complete" class="full-width" />
                    </div>
                    <div class="col-xs-12 col-sm-auto">
                        <q-btn label="Dismiss" color="primary" flat class="full-width" v-close-popup @click="dismiss" />
                    </div>
                </div>
            </q-card-section>
        </q-card>
    </q-dialog>
</template>
<script>

    export default {
        name: 'dialog-subscription-reinstatement',
        props: {
            show: {
                type: Boolean,
                default: false
            },
            items: Array,
        },
        methods: {
            dismiss() {
                this.$store.commit('set_reinstatementItemsViewed', true)
                this.$store.commit('set_showReinstatementCostDialog', false)
            },
            complete() {
                this.dismiss()
                this.$router.push('/store/cart')
            }
        },
        computed: {
            showModal: {
                get() {
                    return this.show
                },
                set(value) {
                    this.$store.commit('set_showReinstatementCostDialog', value)
                }
            },
        },
    }
</script>
